import * as jwt from 'jose'

import {
  IUniToast_Alert,
  EMessageType
} from '@unikey/unikey-commons/release/comm'

import {
  devLogger
} from '../internal'

type IAlerter = (config: IUniToast_Alert) => void;

export const checkJWTExpired = (decodedToken: any, dispatch?: any, alerter?: IAlerter): boolean => {
  const nowMs = Date.now();
  // ensure token is still within the pre-expiration period
  const isExpired = (decodedToken.exp * 1000) < nowMs;
  if (isExpired && alerter && dispatch) {
    dispatch(alerter({
      id: Date.now(),
      type: EMessageType.warn,
      titleKey: 'tokenExpired',
      messageKeys: ['_tokenExpiredExplination']
    }));
  }
  return isExpired;
}
